import type { Directive, DirectiveBinding } from 'vue'
import { usePermissionsStore } from '@/stores/permissions.store'
import type { Permission } from '@/auth/permissions'

type CanValue = Permission | Permission[]

function check(value: CanValue, modifiers: Partial<Record<string, boolean>>): boolean {
  const store = usePermissionsStore()
  const list = Array.isArray(value) ? value : [value]
  if (list.length === 0) return true
  return modifiers.all
    ? list.every((p) => store.permissions.has(p))
    : list.some((p) => store.permissions.has(p))
}

function apply(el: HTMLElement, binding: DirectiveBinding<CanValue>) {
  const allowed = check(binding.value, binding.modifiers)
  if (!allowed) {
    el.style.display = 'none'
    el.setAttribute('aria-hidden', 'true')
  } else {
    el.style.removeProperty('display')
    el.removeAttribute('aria-hidden')
  }
}

export const vCan: Directive<HTMLElement, CanValue> = {
  mounted: apply,
  updated: apply,
}
